import React from 'react'
import Hero from '../Hero'
import Quates from '../Quates'
import Question from '../Question'
import Header from '../Header'
import Footer from '../Footer'
const Home = () => {
  return (
    <div><Header/>
        <Hero />
        <Quates />
        <Question />
        <Footer/>
    </div>
  )
}

export default Home